import { Components, Theme } from "@mui/material";

export const MuiStepContent: Components<
  Omit<Theme, "MuiStepContent">
>["MuiStepContent"] = {
  styleOverrides: {
    root: ({ theme: { palette } }) => ({
      marginLeft: "16px",
      paddingLeft: 38,
      borderColor: palette.custom.purple[400],
      fontSize: 14,
      color: "#00000080",
    }),
  },
};
